import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
} from '@ionic/angular';
import { Options } from 'selenium-webdriver';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})
export class SignupPage implements OnInit {
  submitAttempt: boolean = false;
  signupForm: FormGroup;
  // masks: any;
  data: any;
  phone: any;
  PassType = 'password';
  profile_complete: any;
  formatedPhone: string;
  mask = [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  masks = {
    phoneNumber: [
      '(',
      /[1-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
    cardNumber: [
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
    cardExpiry: [/[0-1]/, /\d/, '/', /[1-2]/, /\d/],
    orderCode: [/[a-zA-z]/, ':', /\d/, /\d/, /\d/, /\d/],
  };
  constructor(
    public loadingCtrl: LoadingController,
    private nativeStorage: NativeStorage,
    public globals: GlobalVariable,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public server: ServerService,
    public formBuilder: FormBuilder,
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
    this.data = {};
    // this.phone = this.navParams.get('phone');
    // this.profile_complete = this.navParams.get('profile_complete');
    this.data.response = '';
  }
  close() {
    this.navCtrl.pop();
  }
  togglePassword() {
    console.log('toggle');
    this.PassType = (<HTMLInputElement>document.getElementById('pass')).type;

    if (this.PassType === 'password') {
      console.log('toggle', this.PassType);

      this.PassType = 'text';
      (<HTMLInputElement>document.getElementById('pass')).type = this.PassType;
    } else {
      this.PassType = 'password';
      (<HTMLInputElement>document.getElementById('pass')).type = this.PassType;
      console.log('toggle', this.PassType);
    }
  }
  ngOnInit() {
    if (!this.profile_complete) {
      this.signupForm = this.formBuilder.group({
        firstName: new FormControl(
          '',
          Validators.compose([
            Validators.maxLength(30),
            Validators.pattern('[a-zA-Z ]*'),
            Validators.required,
          ])
        ),
        lastName: new FormControl(
          '',
          Validators.compose([
            Validators.maxLength(30),
            Validators.pattern('[a-zA-Z ]*'),
            Validators.required,
          ])
        ),
        email: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(
              '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'
            ),
          ])
        ),
        phone: new FormControl(
          this.phone,
          Validators.compose([, Validators.required])
        ),
        // nextdigits: ['', Validators.compose([Validators.maxLength(4), Validators.required])],
        password: new FormControl(
          '',
          Validators.compose([Validators.minLength(6), Validators.required])
        ),
        phonecode: new FormControl(
          '1',
          Validators.compose([Validators.required])
        ),
        // age : ['', Validators.compose([Validators.maxLength(3),Validators.pattern('[0-9]*')])],
        // gender: ['', Validators.compose([Validators.required])],
      });
    } else {
      this.signupForm = this.formBuilder.group({
        firstName: new FormControl(
          '',
          Validators.compose([
            Validators.maxLength(30),
            Validators.pattern('[a-zA-Z ]*'),
            Validators.required,
          ])
        ),
        lastName: new FormControl(
          '',
          Validators.compose([
            Validators.maxLength(30),
            Validators.pattern('[a-zA-Z ]*'),
            Validators.required,
          ])
        ),
        email: new FormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(
              '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'
            ),
          ])
        ),
        phone: new FormControl(
          this.phone,
          Validators.compose([
            Validators.maxLength(10),
            Validators.pattern('[0-9]*'),
            Validators.required,
          ])
        ),
        // nextdigits: ['', Validators.compose([Validators.maxLength(4), Validators.required])],
        password: new FormControl(
          '',
          Validators.compose([Validators.minLength(6), Validators.required])
        ),
        phonecode: new FormControl(
          '1',
          Validators.compose([Validators.required])
        ),
        // age : ['', Validators.compose([Validators.maxLength(3),Validators.pattern('[0-9]*')])],
        // gender: ['', Validators.compose([Validators.required])],
      });
    }
  }
  back() {
    this.navCtrl.pop();
  }
  addKeys(e) {
    console.log(e);
  }
  numberChange() {
    console.log('here');
    this.formatedPhone = String(this.signupForm.value.phone);
    var cleaned = ('' + this.formatedPhone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      this.formatedPhone =
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3];
      console.log(this.formatedPhone);
    }
    // var match = cleaned.match( /^(\d{3})(\d{3})(\d{4})$/)
    // if (match) {

    //     console.log('match')
    //   this.formatedPhone= '(' + match[1] + ') ' + match[2] + '-' + match[3]
    // }
    return null;
    // var clean = this.formatedPhone.replace(/[^\d]/g, '')
    // console.log(clean)
    // this.formatedPhone = clean.replace(/[0-9]{3}-[0-9]{3}-[0-9]{4}/g,'');
    // console.log(this.formatedPhone)
  }
  next(signupData: any) {
    var cleaned = ('' + this.signupForm.value.phone).replace(/\D/g, '');
    // this.signupForm.value.phone=cleaned;
    if (!this.signupForm.valid) {
      console.log(
        ' Some values were not given or were incorrect, please fill them'
      );
      this.submitAttempt = true;
    } else {
      localStorage.setItem('firstname', signupData.firstName);
      localStorage.setItem('lastname', signupData.lastName);
      // localStorage.setItem("password", signupData.password);
      this.globals.PhoneNo = '+' + signupData.phonecode + signupData.phone;
      this.globals.Email = signupData.email;
      console.log('register_data', signupData);

      this.register(signupData, cleaned);
    }
  }

  // MobileVerificationPrompt() {
  //     let model = this.modalCtrl.create(MobileVerificationPromptPage);
  //     model.present();
  // }

  async register(signupData, phone) {
    this.globals.Loader();
    // let loading = await this.loadingCtrl.create({
    //     message: "Please wait...",
    //     backdropDismiss: true,
    // });
    // this.globals.loading.present();
    var cleaned = ('' + this.signupForm.value.phone).replace(/\D/g, '');
    let cleanEmail=this.signupForm.value.email.trim();
    // let cleanEmail=this.loginForm.value.email.replace(/\s/g, '');
    this.signupForm.get('email').setValue(cleanEmail);
    console.log(cleaned);

    let response = this.server.SignupData(
      false,
      signupData.firstName,
      signupData.lastName,
      signupData.email.trim(),
      signupData.password,
      '+1' + cleaned,
      signupData.birthday,
      signupData.aniversary,
      this.profile_complete
    );
    response.subscribe(
      async (data) => {
        this.globals.loading.dismiss();
        console.log('Register res - ', data);

        this.data.response = data;
        if (this.data.response.status != 'error') {
          this.globals.guess_login = false;
          // this.navCtrl.setRoot('AcceptTermsPage', { imageData: this.data.response.url, discountText: this.data.response.discount_text, Flag: true, discount: this.data.response.discount_value });
          this.globals.firstName = signupData.firstName;
          this.globals.lastName = signupData.lastName;
          this.globals.udid = this.data.response.udid;
          localStorage.setItem('isLogin', JSON.stringify(true));
          localStorage.setItem('firstname', signupData.firstName);
          localStorage.setItem('udid', this.data.response.udid);
          localStorage.setItem('userEmail', signupData.email.trim());
          localStorage.setItem('userphone', cleaned);
          this.globals.loading.dismiss();
          this.getNotificationData();
          this.loadBanner();
          this.nativeStorage
            .setItem('user', {
              email: signupData.email.trim(),
              udid: this.data.response.udid,
              firstName: signupData.firstName,
              lastName: signupData.lastName,
              phone: cleaned,
              password: signupData.password,
              image: this.data.response.url,
              ID: this.data.response.id,
              date: this.data.response.date_joined,
              discountValue: this.data.response.discount_value,
              birthday: signupData.birthday,
              aniversary: signupData.aniversary,
            })
            .then(() => {
              this.nativeStorage
                .setItem('discount', {
                  discountValue: this.data.response.discount_value,
                })
                .then(
                  () => console.log('Stored item!'),
                  (error) => console.error('Error storing item', error)
                );
              // console.log("b discount value", this.data.response.discount_value);
              this.globals.udid = this.data.response.udid;
              //  this.server.initializePushToken();
              if (this.globals.caos_flag) {
                this.navCtrl.navigateForward('cart');
              } else {
                this.navCtrl.navigateRoot('accept-terms', {
                  state: {
                    imageData: this.data.response.url,
                    discountText: this.data.response.discount_text,
                    Flag: true,
                    discount: this.data.response.discount_value,
                  },
                });
              }
            })
            .catch((err) => {
              this.globals.loading.dismiss();
              console.log(err);
              if (this.globals.caos_flag) {
                this.navCtrl.navigateForward('cart');
              } else {
                this.globals.loading.dismiss();

                this.navCtrl.navigateRoot('accept-terms', {
                  state: {
                    imageData: this.data.response.url,
                    discountText: this.data.response.discount_text,
                    Flag: true,
                    discount: this.data.response.discount_value,
                  },
                });
              }
            });
        } else {
          this.globals.loading.dismiss();
          let alert = await this.alertCtrl.create({
            subHeader: this.data.response.description,
            buttons: ['Retry'],
          });

          alert.present();

          this.navCtrl.navigateRoot('login');
        }
      },
      (error) => {
        this.globals.loading.dismiss();

        this.globals.presentToast('Server times out, please try again');
      }
    );
  }
  getNotificationData() {
    if (this.globals.userId) {
      let response = this.server.getNotificationData(
        this.globals.oneSignalAppId,
        this.globals.userId,
        this.globals.udid
      );
      response.subscribe((data) => {
        console.log('notification api response', data);
      });
    } else {
      console.log('notsending ');
    }
  }
  // DoMobileVerification(signupData) {
  //     let loading =await  this.loadingCtrl.create({
  //         content: "Please wait...",
  //         dismissOnPageChange: true,
  //     });
  //     loading.present();

  //     let response = this.server.MobileVerification();
  //     response.subscribe(data => {
  //         console.log(data);
  //         var verficationResponse = data;
  //         console.log(verficationResponse);
  //         loading.dismiss();
  //         if (verficationResponse.status == true) {
  //             this.globals.signupData = signupData;
  //             this.navCtrl.push('MobileEmailVarificationPage');
  //         } else {
  //             // this.register(signupData);

  //             let alert = this.alertCtrl.create({
  //                 title: "Error",
  //                 message: verficationResponse.message,
  //                 buttons: ["OK"]
  //             });
  //             alert.present();
  //         }

  //     }, error => { console.log(error); });
  // }
  loadBanner() {
    let response = this.server.LoadBannersOnHomePage();
    response.subscribe(
      (data) => {
        console.log('banners', data);
        this.globals.banner_color = data.banner_color;
        this.globals.giftCard_color = data.gift_cards_color;
        this.globals.myRewards_color = data.my_rewards_color;
        this.globals.orderNow_color = data.order_now_color;
        this.globals.specialOffer_color = data.special_offer_color;
        this.globals.themeColor = data.theme_color;
        // this.globals.cash_discount = data.cash_discount;

        // this.globals.cash_discount_enabled = data.cash_discount_enabled;
        // this.globals.cash_discount_percentage = data.cash_discount_percentage;
        // this.globals.cash_discount_value = data.cash_discount_value;

        //newadded
        this.globals.BusinessDiscount = data.discount;
        this.globals.availed_discount_count = parseInt(
          data.customer_discount_availed_count
        );
        this.globals.business_discount_count = parseInt(
          data.business_discount_count
        );
        //new added
        // ll
        if (data.theme_color) {
          this.globals.appColor = data.theme_color;
        } else {
          this.globals.appColor = '#000000';
        }

        // this.globals.cash_discount = data.cash_discount;

        // this.globals.cash_discount_enabled = data.cash_discount_enabled;
        // this.globals.cash_discount_percentage = data.cash_discount_percentage;
        // this.globals.cash_discount_value = data.cash_discount_value;
      },
      async (error) => {
        console.log('no network', error);
        let alert = await this.alertCtrl.create({
          message:
            "Looks like you're not connected to Internet. turn on your mobile data or Wi-Fi.",
          buttons: ['OK'],
        });
        alert.present();
      }
    );
  }
}
